export default {
  dashboard: {
    realmName: "{{name}} realm",
    welcome: "Welcome to",
    introduction: "If you want to leave this page and mange this realm, please click the corresponding menu items in the left navigation bar.",
    serverInfo: "Server info",
    version: "Version",
    product: "Product",
    profile: "Profile",
    enabledFeatures: "Enabled features",
    experimental: "Experimental",
    preview: "Preview",
    infoEnabledFeatures: "Something about what enabled features are.",
    infoDisabledFeatures: "Something about what disabled features are.",
    disabledFeatures: "Disabled features",
    adminUiVersion: '<0 class="pf-u-mr-md">Admin UI version</0>{{version}}'
  }
};
